import { parseISO } from 'date-fns'
import { todayKey } from '@/utils/businessDay'

/**
 * 排班页的「今天」一律按用户时区算（与同页按 useUserTimezone() 显示的时刻、
 * buildShiftRangeISO 建班一致），不用 date-fns isToday / new Date() 的浏览器时区——
 * 浏览器与用户时区不同时，跨日前后会差一天。
 */

/** 'yyyy-MM-dd' of "today" in the given IANA timezone. */
export function todayInTimezone(timezone: string, now: Date = new Date()): string {
  return todayKey(timezone, now)
}

/**
 * 用户时区的今天，作为日历网格用的本地午夜 Date（网格日期都是浏览器本地 Date，
 * 用 format(day, 'yyyy-MM-dd') 取日历标签）。
 */
export function todayDateInTimezone(timezone: string, now: Date = new Date()): Date {
  return parseISO(todayInTimezone(timezone, now))
}
